// Export things like public API, and interfaces from here.
export * from './src/confirmation-modal.module';
